import React, { Component } from 'react';
import PageHelmet from './Helmet';
import Breadcrumb from './Breadcrumb';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import BrandTwo from './BrandTwo';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Header from '../../Layout/Main/header/Header';
import Footer from '../../Layout/Main/footer/FooterTwo';
import aboutImg3 from '../../assets/images/about/about-3.png';
import teamImg1 from '../../assets/images/team/team-01.jpg';
import teamImg2 from '../../assets/images/team/team-02.jpg';
import teamImg3 from '../../assets/images/team/team-03.jpg';
import MoonlineImage from '../../assets/images/service/MOONLM.png'
import Care from '../../assets/Care.png'
import Punctual from '../../assets/Punctual.png'
import Convenience from '../../assets/Convenience.png'
import Affordable from '../../assets/Affordable.png'

class About extends Component {
	render() {
		let title = 'About Us',
			description =
				'We are a full service moving company located in Vancouver, BC. We are a go-to choice for families and companies when it comes to moving services. With our ethical and professional business practices, we make your move comfortable and effortless. We are committed to providing you with a positive moving experience.';
		return (
			<React.Fragment>
				<PageHelmet pageTitle='About' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />
				{/* Start Breadcrump Area */}

				{/* End Breadcrump Area */}

				{/* Start About Area  */}
				<div className='rn-page-title-area pt--50 pb--190 bg_image bg_image--17 background-img-about mt--90'>
					<div className='rn-about-wrapper'>
						<div className='container' style={{maxWidth:'90%'}}>
							<div className='row row--35'>
								{/* <div className='col-lg-4'>
									<div style={{marginTop:'50px', display:'flex', justifyContent:'center'}}>
										<img style={{width:'70%'}} src={MoonlineImage} alt='About Images' />
									</div>
									<div className='header-btn' style={{display:'flex', justifyContent: 'center', marginTop: '50px'}}>
										<a className='rn-btn' href='/clientinformation'>
											<span>Get Free Moving Estimate Now!</span>
										</a>
									</div>
									
								</div> */}
								<div className='col-lg-12'>
									<div className='about-inner inner'>
										<div className='section-title'>
											<h2 className='title text-center'>{title}</h2>
											<p className='description text-center'>{description}</p>
										</div>
										<div className='row mt--30'>
											
												
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title text-center'>Our Values</h3>
													<p className='text-center'>We are also known for our values. We treat your belongings as our own when you choose us as your moving partner. All our staff is well educated and trained. You can be sure that your belongings will be safe and secure in our hands. We don’t interfere with your privacy and your products will be moved to your destination as they were packed in front of your eyes. We work for the satisfaction of our customers so we always go an extra mile with our services.</p>
												</div>
											</div>
										<div className='col-lg-12 col-md-12 col-sm-12 col-12 pt--50'>
											<div className='about-us-list'>
													<h3 className='title text-center pb--10'>Why We are Different </h3>
													<div className='row'>
														<div className='col-lg-6 col-md-12 col-sm-12 col-12'>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<img style={{width:'150px'}} src={Care} alt='About Images' />
															</div>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<h3 className='title'>Care</h3>
															</div>
															<p className='text-center'>We truly care about you.</p>
															<p className='text-center'>We know moving can be very stressful,</p>
															<p className='text-center'>And we believe our duty as your mover</p>
															<p className='text-center'>Is to take this load-off of your plate so you</p>
															<p className='text-center'>Can focus on your new-chapter of your</p>
															<p className='text-center'>Life.</p>
															
															<div className='pt--100' style={{display:'flex', justifyContent: 'center'}}>
																<img style={{width:'150px'}} src={Punctual} alt='About Images' />
															</div>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<h3 className='title '>Punctual</h3>
															</div>
															<p className='text-center'>We understand time-is-of-the-essence.</p>
															<p className='text-center'>Usually, people move during the first, middle, and last day</p>
															<p className='text-center'>of the month. These are very stringent times, </p>
															<p className='text-center'>where a one-hour delay can cause you and other unpleasant feelings. </p>
															<p className='text-center'>Therfere, we value time IMMENSELY!</p>
														</div>
														
														<div className='col-lg-6 col-md-12 col-sm-12 col-12'>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<img style={{width:'150px'}} src={Affordable} alt='About Images' />
															</div>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<h3 className='title'>Affordable</h3>
															</div>
															<p className='text-center'>Sometimes moving can be expansive.</p>
															<p className='text-center'>We listened to our customers and feel their pain.</p>
															<p className='text-center'>Therefore, We managed to work out a deal with our Bank, </p>
															<p className='text-center'>having our customers in mind And in the heart. </p>
															<p className='text-center'>We are very proud to offer to our customers</p>
															<p className='text-center'>the moonline Flex-Pay Program. </p>
															<p className='text-center'>To learn more about this program. </p>
															<p className='text-center'><a href="tel:+1605595280">Please call us</a></p>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<img style={{width:'160px'}} src={Convenience} alt='About Images' />
															</div>
															<div style={{display:'flex', justifyContent: 'center'}}>
																<h3 className='title'>Convenience</h3>
															</div>
															<p className='text-center'>We are a One-Stop-Shop moving company. </p>
															<p className='text-center'>You do not need to worry about packing, unpacking, </p>
															<p className='text-center'>Search for your moving supplies somewhere else, </p>
															<p className='text-center'>or even struggle to find storage if you are between places.</p> 
															<p className='text-center'>We’ve got you covered. Just <a href="tel:+1605595280">give us a call,</a> </p>
															<p className='text-center'>and one of our professional moving specialiests  will be </p>
															<p className='text-center'>glad to arrange everything for you. </p>

														</div>
													</div>
													
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End About Area  */}

				{/* Start CounterUp Area */}
				{/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
				{/* End CounterUp Area */}

				{/* Start Finding Us Area  */}
				{/* <div className='rn-finding-us-area rn-finding-us bg_color--1'>
					<div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div>
				</div> */}
				{/* End Finding Us Area  */}

				{/* Start Team Area  */}
				{/* <div className='rn-team-area bg_color--1 ptb--120'>
					<div className='container'> */}
						{/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
						{/* <div className='row'>
							<div className='col-lg-4 col-md-6 col-sm-6 col-12'>
								<div className='team'>
									<div className='thumbnail'>
										<img className='w-100' src={teamImg1} alt='Blog Images' />
									</div>
									<div className='content'>
										<h4 className='title'>Jone Due</h4>
										<p className='designation'>Sr. Web Developer</p>
									</div>
									<ul className='social-icon'>
										<li>
											<a href='https://www.facebook.com/'>
												<FaFacebookF />
											</a>
										</li>
										<li>
											<a href='http://linkedin.com/'>
												<FaLinkedinIn />
											</a>
										</li>
										<li>
											<a href='https://twitter.com/'>
												<FaTwitter />
											</a>
										</li>
									</ul>
								</div>
							</div> */}
							{/* End Single Team  */}

							{/* Start Single Team  */}
							{/* <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
								<div className='team'>
									<div className='thumbnail'>
										<img className='w-100' src={teamImg2} alt='Blog Images' />
									</div>
									<div className='content'>
										<h4 className='title'>BM. Alamin</h4>
										<p className='designation'>Sr. Web Developer</p>
									</div>
									<ul className='social-icon'>
										<li>
											<a href='https://www.facebook.com/'>
												<FaFacebookF />
											</a>
										</li>
										<li>
											<a href='http://linkedin.com/'>
												<FaLinkedinIn />
											</a>
										</li>
										<li>
											<a href='https://twitter.com/'>
												<FaTwitter />
											</a>
										</li>
									</ul>
								</div>
							</div> */}
							{/* End Single Team  */}

							{/* Start Single Team  */}
							{/* <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
								<div className='team'>
									<div className='thumbnail'>
										<img className='w-100' src={teamImg3} alt='Blog Images' />
									</div>
									<div className='content'>
										<h4 className='title'>Jone Due</h4>
										<p className='designation'>Sr. Web Developer</p>
									</div>
									<ul className='social-icon'>
										<li>
											<a href='https://www.facebook.com/'>
												<FaFacebookF />
											</a>
										</li>
										<li>
											<a href='http://linkedin.com/'>
												<FaLinkedinIn />
											</a>
										</li>
										<li>
											<a href='https://twitter.com/'>
												<FaTwitter />
											</a>
										</li>
									</ul>
								</div>
							</div> */}
							{/* End Single Team  */}
						{/* </div> */}
					{/* </div>
				</div> */}
				{/* End Team Area  */}

				{/* Start Testimonial Area */}
				{/* <div className='rn-testimonial-area bg_color--5 ptb--120'>
					<div className='container'>
						<Testimonial />
					</div>
				</div> */}
				{/* End Testimonial Area */}

				{/* Start Brand Area */}
				{/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
				{/* End Brand Area */}

				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default About;
